module.exports = __webpack_public_path__ + "b8f7916c6c326e9c0772925a8e0d05b7.gif";